
export class PDFTitleInfo {
  constructor(
    public title: string,
    public subtitle?: string
  ) { }
}
